// Shubham code
import React, { useEffect, useState } from "react";
import HRNavbar from "../../../HR/HRNavbar";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  useMediaQuery,
  CircularProgress,
  TextField,
  Button,
  AppBar,
  InputBase,
  Menu,
  MenuItem,
  Modal,
  Card,
  CardContent,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableContainer,
  TablePagination,
  Tooltip,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/system";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

import Footer from "../../../../Footer";
import { GridCheckCircleIcon, GridCloseIcon } from "@mui/x-data-grid";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { API_URL } from "../../../Config/api";
import ProfRequestPayoutmodal from "./ProfRequestPayoutmodal";
const customStyles = {
  "& .Mui-focused": {
    outline: "none",
  },
};
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  pt: 2,
  px: 4,
  pb: 3,
};
const OngoingServiceCard = styled(Card)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: "10px",
  backgroundColor: "white",
  boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
  height: "3rem",
  borderRadius: "10px",
  transition: "0.5s ease-in-out",
  "&:hover": {
    backgroundColor: "#F7F7F7",
    cursor: "pointer",
    borderLeft: "4px solid #A5D6A7",
    borderRight: "4px solid #A5D6A7",
  },
});

const filterBoxStyle = {
  p: "2px 4px",
  display: "flex",
  alignItems: "center",
  width: 200,
  height: "2.5rem",
  backgroundColor: "#ffffff",
  boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
  borderRadius: "10px",
  border: "1px solid #C9C9C9",
};

const ProfRequestPayout = () => {
  const accessToken = localStorage.getItem("token");

  const [isSmallScreen, setIsSmallScreen] = useState(false); // Mock for screen size
  const [loading, setLoading] = useState(false);
  const [onServices, setOnServices] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [tableHeight, setTableHeight] = useState("auto");

  const [eventID, setEventID] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedService, setSelectedService] = useState("");

  const [openViewModal, setOpenViewModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [serviceList, setServiceList] = useState([]);
  const [professionalList, setProfessionalList] = useState([]);
  const [selectedProfessional, setSelectedProfessional] = useState("");
  const [isFiltered, setIsFiltered] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  // success | error | warning | info

  console.log("eventID", eventID);

  const filteredData = onServices.filter((item) => {
    // future search / date filter logic
    return true;
  });

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  // ************** API Integration **********************************************

  useEffect(() => {
    const fetchprofessionalPayoutRequests = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(
          `${API_URL}/pay_out/payout_request_approve_reject_list/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const apiData = response.data;
        console.log("FULL API RESPONSE:", apiData);

        if (Array.isArray(apiData)) {
          setOnServices(apiData);
        } else if (Array.isArray(apiData.data)) {
          setOnServices(apiData.data);
        } else if (Array.isArray(apiData.requests)) {
          setOnServices(apiData.requests);
        } else {
          console.error("Unknown API structure:", apiData);
          setOnServices([]);
        }
      } catch (error) {
        console.error("API error:", error);
        setOnServices([]);
      } finally {
        setLoading(false);
      }
    };

    fetchprofessionalPayoutRequests();
  }, []);

  useEffect(() => {
    // Set screen size state dynamically
    const handleResize = () => setIsSmallScreen(window.innerWidth < 600);
    window.addEventListener("resize", handleResize);
    handleResize(); // Initial call
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // *****************************************************************************

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

useEffect(() => {
  const setDynamicHeight = () => {
    // 100vh se top navbar (14.6mt) aur footer minus karke calculate karein
    const calculatedHeight = window.innerHeight - 350;
    setTableHeight(calculatedHeight + "px");
  };
  setDynamicHeight();
  window.addEventListener("resize", setDynamicHeight);
  return () => window.removeEventListener("resize", setDynamicHeight);
}, []);

const handleView = (row) => {
  setSelectedRow(row);
  setOpenViewModal(true);
};

  const handleCloseViewModal = () => {
    setOpenViewModal(false);
    setSelectedRow(null);
  };
  return (
    <>
      <HRNavbar />
      <Box sx={{ flexGrow: 1, mt: 14.6, ml: 1, mr: 1, mb: 3 }}>
        <Stack
          direction={isSmallScreen ? "column" : "row"}
          spacing={1}
          alignItems={isSmallScreen ? "center" : "flex-start"}
          sx={{ pt: 1 }}
        >
           <Typography
                     variant="h6"
                     sx={{ fontWeight: 700, color: "#205964", mr: 2 }}
                   >
                      Professional Payout Requests
                   </Typography>
         
        </Stack>

        <TableContainer
          sx={{
            height: "60vh", 
            overflowY: "auto", 
            mt: 2,
          }}
        >
         <Table stickyHeader aria-label="sticky table">
            {/* ================= HEADER ================= */}
            <TableHead>
              <TableRow>
                <OngoingServiceCard
                  style={{
                    background: "#a6b4be",
                    color: "#000000ff",
                    borderRadius: "8px 10px 0 0",
                  }}
                >
                  <CardContent
                    style={{ flex: 0.5, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Sr. No</Typography>
                  </CardContent>

                  <CardContent
                    style={{ flex: 1.2, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Professional Name</Typography>
                  </CardContent>

                  <CardContent
                    style={{ flex: 1.2, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Mobile No</Typography>
                  </CardContent>

                  <CardContent
                    style={{ flex: 2, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Email</Typography>
                  </CardContent>

                  <CardContent
                    style={{ flex: 1.5, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">
                      Bank Verification
                    </Typography>
                  </CardContent>

                  <CardContent style={{ flex: 0.5 }}>
                    <Typography variant="subtitle2">Action</Typography>
                  </CardContent>
                </OngoingServiceCard>
              </TableRow>
            </TableHead>

            {/* ================= BODY ================= */}
            {loading ? (
              <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
                <CircularProgress />
              </Box>
            ) : (
              <TableBody>
                {onServices.length === 0 ? (
                  <TableRow>
                    <CardContent>
                      <Typography variant="body2">No Data Available</Typography>
                    </CardContent>
                  </TableRow>
                ) : (
                  onServices
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        key={row.srv_prof_id || index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          height: "3.5rem",
                        }}
                      >
                        <OngoingServiceCard
                          sx={{ display: "flex", height: "3.5rem" }}
                        >
                          {/* Sr No */}
                          <CardContent sx={{ flex: 0.5 }}>
                            <Typography variant="body2">
                              {index + 1 + page * rowsPerPage}
                            </Typography>
                          </CardContent>

                          {/* Professional Name */}
                          <CardContent sx={{ flex: 1.2 }}>
                            <Typography variant="body2" align="center">
                              {row.prof_name || "-"}
                            </Typography>
                          </CardContent>

                          {/* Mobile */}
                          <CardContent sx={{ flex: 1.2 }}>
                            <Typography variant="body2" align="center">
                              {row.prof_phone || "-"}
                            </Typography>
                          </CardContent>

                          {/* Email */}
                          <CardContent sx={{ flex: 2 }}>
                            <Typography variant="body2" align="center">
                              {row.prof_email || "-"}
                            </Typography>
                          </CardContent>

                          {/* Bank Verification */}
                          <CardContent
                            sx={{
                              flex: 1.5,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Tooltip
                              title={
                                row.prof_bank_verification
                                  ? "Bank details verified by admin"
                                  : "Bank details not verified yet"
                              }
                              arrow
                            >
                              <Typography
                                variant="body2"
                                align="center"
                                sx={{
                                  color: row.prof_bank_verification
                                    ? "success.main"
                                    : "error.main",
                                  fontWeight: 600,
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  cursor: "pointer",
                                }}
                              >
                                {row.prof_bank_verification ? (
                                  <>
                                    <GridCheckCircleIcon
                                      sx={{
                                        fontSize: 18,
                                        color: "success.main",
                                      }}
                                    />
                                    Verified
                                  </>
                                ) : (
                                  <>
                                    <GridCloseIcon
                                      sx={{ fontSize: 18, color: "error.main" }}
                                    />
                                    Not Verified
                                  </>
                                )}
                              </Typography>
                            </Tooltip>
                          </CardContent>

                          {/* Action */}
                          <CardContent
                            sx={{
                              flex: 0.5,
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <Button
                              variant="contained"
                              size="small"
                              sx={{
                                textTransform: "none",
                                minWidth: "60px",
                                backgroundColor: "#a6b4be",
                                "&:hover": {
                                  backgroundColor: "#8e9ea8",
                                },
                              }}
                              onClick={() => handleView(row)}
                            >
                              View
                            </Button>
                          </CardContent>
                        </OngoingServiceCard>
                      </TableRow>
                    ))
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>

        <TablePagination
          sx={{ overflowY: "hidden" }}
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={onServices.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        <Modal open={openViewModal} onClose={handleCloseViewModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "98%",
              height: "90vh",
              bgcolor: "background.paper",
              borderRadius: "12px",
              boxShadow: 24,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            {/* APP BAR */}
            <AppBar
              position="static"
              sx={{
                backgroundColor: "#347B89",
              }}
            >
              <Stack direction="row" alignItems="center" px={2}>
                <Typography sx={{ flexGrow: 1, fontWeight: 600 }}>
                  Details Of Professional Unit
                </Typography>
                <IconButton color="inherit" onClick={handleCloseViewModal}>
                  <CloseIcon />
                </IconButton>
              </Stack>
            </AppBar>

            {/* MODAL BODY */}
            <Box sx={{ p: 3, overflowY: "auto" }}>
              <ProfRequestPayoutmodal row={selectedRow} />
            </Box>
          </Box>
        </Modal>
      </Box>
      <Footer />

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMsg}
        </Alert>
      </Snackbar>
    </>
  );
};
     
export default ProfRequestPayout;
